import React from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";

axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

interface RotaProtegidaProps {
  element: React.ReactNode;
}

const RotaProtegida: React.FC<RotaProtegidaProps> = ({ element }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    // Se não houver token, redirecione para a página de login
    return <Navigate to="/" replace />;
  }
  const tokenValidated = () => {
    const decoded = jwtDecode(token);

    if(decoded.exp! * 1000 < Date.now()){
      return false
    }else{
      return true
    }
  }

  if(!tokenValidated()){
    localStorage.clear()
    return <Navigate to="/" replace />
    
  }

  return <>{element}</>;
};


export default RotaProtegida;
